export default "__VITE_ASSET__BaxlrHlp__"